import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../ui/accordion";

const faqs = [
  {
    question: "¿Necesito experiencia previa para entrenar en Inspirion GYM?",
    answer: "¡Para nada! Recibimos personas de todos los niveles, desde principiantes absolutos hasta deportistas experimentados. Tu plan de entrenamiento se diseña específicamente según tu nivel actual, y tu entrenador te guía en cada ejercicio para que aprendas la técnica correcta desde el primer día.",
  },
  {
    question: "¿La clase gratis es sin compromiso?",
    answer: "Totalmente. La clase gratis es para que conozcas nuestro método, nuestras instalaciones y a nuestro equipo. No hay letra chica ni presión para inscribirte. Queremos que decidas con toda la información disponible.",
  },
  {
    question: "¿Puedo entrenar si llevo tiempo sin hacer ejercicio?",
    answer: "¡Por supuesto! De hecho, muchos de nuestros alumnos llegaron después de años sin actividad física. Diseñamos tu plan considerando tu condición actual y vamos progresando de forma segura. Lo importante es dar el primer paso.",
  },
  {
    question: "¿Qué incluye el entrenamiento personalizado?",
    answer: "Incluye una evaluación inicial de tu condición física, un plan de entrenamiento diseñado para tus objetivos específicos, acompañamiento de un entrenador en cada sesión, ajustes semanales según tu progreso, y orientación nutricional básica.",
  },
  {
    question: "¿Cuántas veces a la semana debo entrenar?",
    answer: "Depende de tus objetivos y disponibilidad de tiempo. Generalmente recomendamos entre 3 a 5 sesiones semanales para ver resultados óptimos, pero adaptamos el plan a tu realidad. Incluso con 2 sesiones semanales puedes ver mejoras significativas.",
  },
  {
    question: "¿Cuánto tiempo tardaré en ver resultados?",
    answer: "Con constancia, la mayoría de nuestros alumnos notan cambios en las primeras 4 semanas: más energía, mejor postura y mayor fuerza. Los cambios físicos visibles suelen verse entre las 8 y 12 semanas. Cada cuerpo es diferente, pero lo importante es el progreso constante.",
  },
];

export const FAQSection = () => {
  return (
    <section 
      id="faq"
      data-testid="faq-section"
      className="relative py-24 bg-dark-paper"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-left mb-12"
        >
          <span className="text-neon-magenta text-sm font-bold uppercase tracking-widest">
            FAQ
          </span>
          <h2 className="mt-4 text-4xl md:text-5xl font-black uppercase tracking-tight text-white">
            Preguntas
            <br />
            <span className="text-neon-cyan text-glow-cyan">Frecuentes</span>
          </h2>
          <p className="mt-6 text-lg text-gray-400">
            Todo lo que necesitas saber antes de empezar tu transformación.
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="bg-dark-card border border-white/5 px-6 data-[state=open]:border-neon-green/30"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left text-white hover:text-neon-green font-bold py-6 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 pb-6 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};

export default FAQSection;
